// extracted by mini-css-extract-plugin
export var aircallIframe = "_kv-3";
export var fabContainer = "_kv-5";
export var fabRinging = "_kv-6";
export var loadingOverlay = "_kv-4";
export var pulse = "_kv-7";
export var widgetContent = "_kv-2";
export var widgetPanel = "_kv-0";
export var widgetPanelExpanded = "_kv-1";